import { colourStyles } from "../../../Utils/styled-components/react-select.style"
import Select from 'react-select'
import React, { useEffect, useMemo, useState } from 'react'
import { useFieldArray, useFormContext, Controller, useWatch } from "react-hook-form"

export const WasteBranch = ({branchIndex, waste, units, getName, displayOther, loadingSet }) => {
    const { control, formState: { errors }, watch, register, setValue, unregister } = useFormContext()
    const { fields, append, remove } = useFieldArray({
        control,
        name: `sucursales.${branchIndex}.sucursalResiduos`,
        rules: { 
            minLength: 1
        }
    })

    const wasteMemo = useMemo(() => waste?.map(x => x.id), [waste])

    useEffect(() => {
        if(waste?.length > 0) {
            setWasteInputs()
        }
    }, [])

    const setWasteInputs = async () => {
        waste.map((type) => type.residuos.map((y) => append({ id: 0, cantidad: 0, unidadMedidaId: 2, residuoId: y.id, sucursalId: 0 })))
    }

    const watchFieldArray = useWatch(`sucursales.${branchIndex}.sucursalResiduos`);
    const controlledFields = fields.map((field, index) => {
        return {
            ...field,
            ...watchFieldArray[index]
        };
    });
 
    return (
        <div className="border border-bd-light">
            <div className='custom-form grid grid-cols-1 tab-port:grid-cols-[repeat(8,1fr)] gap-x-8 gap-y-6 px-8 py-4'>
                {waste?.length > 0 && waste.map((type, i) => (
                    <React.Fragment key={i}>
                        <div className="col-span-full my-4 text-2xl text-dark font-semibold">
                            {type.nombre}
                            <hr className='my-4 border-bd-primary'></hr>
                        </div>
                        {controlledFields?.map((field, index) => {
                            if (type?.residuos?.find(r => field.residuoId == r.id)) {
                                return (
                                    <React.Fragment key={index}>
                                        <div className="col-span-5 self-start tab-port:self-center text-xl text-font-dark ">
                                            {getName(field?.residuoId) ?? ''}
                                        </div>
                                        <div className="col-span-full tab-port:col-span-3 place-self-start tab-port:place-self-end flex items-center mb-6 tab-port:my-0 gap-x-4">
                                            <input className='custom-form__input' type="number"
                                                {...register(`sucursales.${branchIndex}.sucursalResiduos.${index}.cantidad`, { valueAsNumber: true })} />
                                            <Controller
                                                control={control}
                                                defaultValue={units?.[0]?.id}
                                                name={`sucursales.${branchIndex}.sucursalResiduos.${index}.unidadMedidaId`}
                                                render={({
                                                    field: { onChange, name, value, ref, onBlur },
                                                }) => (
                                                    <Select
                                                        ref={ref}
                                                        onBlur={onBlur}
                                                        styles={colourStyles}
                                                        noOptionsMessage={() => "Sin datos"}
                                                        placeholder="Seleccione"
                                                        isLoading={loadingSet.units}
                                                        getOptionLabel={(option) => option?.abreviatura}
                                                        getOptionValue={(option) => option?.id}
                                                        options={units}
                                                        onChange={(newValue) => onChange(newValue?.id)}
                                                        value={units?.find(c => c?.id === value) ?? null}
                                                    />
                                                )}>
                                            </Controller>
                                        </div>
                                        {displayOther(field?.idResiduo, watch(`sucursales.${branchIndex}.sucursalResiduos.${index}.cantidad`)) && (
                                            <div className="custom-form__control col-span-full">
                                                <label className='custom-form__label'>
                                                    Otros Residuos
                                                </label>
                                                <textarea className="custom-form__input" name="descripcion" id="descripcion" cols="30" rows="2"
                                                    {...register(`sucursales.${branchIndex}.sucursalResiduos.${index}.descripcion`)} />
                                            </div>
                                        )}
                                    </React.Fragment>
                                )
                            }
                        })}
                    </React.Fragment>
                )
                )}
            </div>
        </div>
    )
}